export const marketingAutomation = {
  seo: {
    title: "Marketing és social media — Bespire AI asszisztens",
    description:
      "Posztok, kampányok, e-mailek, hirdetések — a Bespire AI asszisztens megírja, kiposztolja és méri. Korlátlan, tisztességes használat mellett.",
  },
  hero: {
    badge: "Marketing és social media",
    title: "A marketinged úgy megy, mintha lenne egy csapatod",
    subtitle:
      "Az asszisztens hetente megtervezi a posztjaidat, megírja a hirdetéseidet, elküldi az e-mail kampányokat — a márkádon, a naptárad ismeretében. Korlátlan, tisztességes használat mellett.",
    ctaTrial: "Próbáld ki 3 napig ingyen",
    ctaPricing: "Nézd meg az árakat →",
    composer: {
      label: "Poszt-szerkesztő · illusztráció",
      channelInstagram: "Instagram",
      channelFacebook: "Facebook",
      channelEmail: "E-mail",
      caption:
        "Csütörtökön újra kismama jóga Bella Studio-ban 💜 Az utolsó 3 hely még szabad — a link a bióban visz a foglaláshoz.",
      hashtags: ["#kismamajóga", "#Bellastudio", "#budapest"],
      image: "Studio · természetes fény · matrac",
      scheduleLabel: "Ütemezve",
      scheduleValue: "Kedd 18:30 · Instagram + Facebook",
      cta: "Ütemezés jóváhagyása",
    },
  },
  process: {
    title: "Három lépés, hogy a marketing magától menjen",
    subtitle:
      "Ugyanaz az asszisztens, ami a foglalást és a weboldalt viszi. Nem külön eszköz — közös adatokból dolgozik.",
    steps: [
      {
        step: "01",
        icon: "Compass",
        title: "Terv, nem véletlen posztok",
        description:
          "A Bespire minden hétre kitalál egy tervet: mit posztolsz, milyen kampányt küldesz, mikor. A naptárad és az árlistád alapján.",
        bullets: [
          "Heti tartalomterv Insta, Facebook és e-mail csatornákra",
          "Szezonális kampányok automatikusan időzítve",
          "Az üzenetek a foglalási naptáradra hangolva",
        ],
      },
      {
        step: "02",
        icon: "PenSquare",
        title: "Megírja és megcsinálja",
        description:
          "Szövegek, hashtag, kép-koncepció, e-mail sablon, hirdetés-variánsok. Egy előnézet, egy jóváhagyás — kimegy.",
        bullets: [
          "Poszt-szövegek a márka hangvételén",
          "Kép-koncepciók és sablonok",
          "Hirdetés-variánsok A/B teszthez",
        ],
      },
      {
        step: "03",
        icon: "BarChart3",
        title: "Méri és tanul",
        description:
          "Látja, melyik poszt vitte a foglalásokat. Nem impressziót — foglalást. Legközelebb abból az irányból hoz több variánsot.",
        bullets: [
          "Bevételre visszavezetett méréssel",
          "Melyik csatorna hozza a valós ügyfelet",
          "Automatikus javaslat, mit érdemes újra futtatni",
        ],
      },
    ],
  },
  beforeAfter: {
    title: "Előtte–utána: ugyanaz a hét",
    subtitle:
      "Nem több munka — kevésbé véletlenszerű megjelenés.",
    before: {
      label: "Előtte",
      businessName: "Ad hoc marketing",
      tagline: "Vasárnap este bepánikolsz, hogy nincs poszt.",
      bio: "Alkalmanként posztolsz, ha van rá idő. E-mailt hónapok óta nem küldtél. Hirdetésre volt egy próbálkozás, nem tudod, mi jött ki belőle.",
      problems: [
        "Poszt akkor van, ha épp van időd",
        "E-mail listád van, csak nem használod",
        "Hirdettél, de nem tudod, mit hozott",
        "Semmi nem kapcsolódik a foglalásaidhoz",
      ],
    },
    after: {
      label: "Utána",
      businessName: "Marketing a Bespire-ből",
      tagline: "Heti terv, kimenő tartalom, mért eredmények.",
      bio: "Hétfőn kész terv, kedden posztok jóváhagyásra, csütörtökön e-mail kampány, vasárnap heti riport arról, mi hozott foglalást.",
      wins: [
        "Heti tartalomterv jóváhagyásra",
        "Automatikus ütemezés minden csatornán",
        "Foglaláshoz kötött mérés",
        "Kampányok szezonokra előre",
      ],
    },
  },
  showcase: {
    title: "A hetedik napra kész heti terv",
    subtitle:
      "Instagram, Facebook, e-mail — az asszisztens előre tervez, te csak jóváhagysz.",
    days: ["Hétfő", "Kedd", "Szerda", "Csütörtök", "Péntek", "Szombat", "Vasárnap"],
    channels: [
      {
        name: "Instagram",
        icon: "Instagram",
        posts: [
          "", "Reel · Kismama jóga snippet", "Story · Ügyfélvélemény", "", "Feed · Hétvégi csomag", "Story · Csoport telítettség", "",
        ],
      },
      {
        name: "Facebook",
        icon: "Facebook",
        posts: [
          "", "Poszt · Új óra csütörtök", "", "Poszt · Blog: relaxáció", "", "Esemény · Szombat 10:00", "",
        ],
      },
      {
        name: "E-mail",
        icon: "Mail",
        posts: [
          "", "", "Kampány · Hétvégi ajánlat", "", "", "", "Havi hírlevél",
        ],
      },
    ],
    campaigns: {
      title: "Egy üzenettel egy egész kampány",
      subtitle: "\"Csinálj egy hétvégi akciót első ügyfeleknek.\" — az asszisztens ebből kihozza az egészet.",
      items: [
        { icon: "PenSquare", title: "3 posztvariáns", note: "Insta feed, Insta reel, Facebook — külön hangvétel" },
        { icon: "Mail", title: "E-mail kampány", note: "Tárgymezők A/B tesztre, szegmentált a régi ügyfelekre" },
        { icon: "Megaphone", title: "Facebook hirdetés", note: "2 kreatív, 2 célközönség, napi keret javaslattal" },
        { icon: "BarChart3", title: "Heti riport", note: "Melyik hozott foglalást, mit érdemes újra futtatni" },
      ],
    },
    fairUse: "Korlátlan, tisztességes használat mellett — a szokásos napi mennyiséghez nem kell aggódnod a limitek miatt.",
    fairUseDetail: "A gyakorlatban ez tipikusan napi 3–5 posztot és havi 2–3 kampányt jelent — ha ennél intenzívebben használnád, egyeztetünk.",
  },
  chat: {
    title: "Kérj egy kampányt, mint egy csapattól",
    subtitle:
      "Csak nem egy hetes brief, hanem egy chat-üzenet.",
    chat: {
      title: "Marketing asszisztens",
      online: "Online",
      messages: [
        { role: "user" as const, content: "Csinálj egy hétvégi akciót első ügyfeleknek, 20% kedvezmény szombatra és vasárnapra." },
        { role: "assistant" as const, content: "Rendben. Amit összeraktam:", list: [
          "📸 3 Insta poszt (feed + 1 reel), márka hangvételen",
          "📧 E-mail kampány a régi ügyfeleidnek — akiknek 3+ hónapja nem volt foglalás",
          "🎯 Facebook hirdetés: 2 kreatív, 2 célközönség (kismamák + dolgozó szülők)",
          "🗓 Weboldalon banner + landing az akcióhoz",
        ] },
        { role: "user" as const, content: "Az e-mailben legyen egy egyedi kód mindenkinek." },
        { role: "assistant" as const, content: "Kész: minden címzett saját kódot kap, csak szombat-vasárnap érvényes, foglaláshoz kötve. Előnézet?" },
        { role: "user" as const, content: "Előnézet, aztán menjen." },
        { role: "assistant" as const, content: "Előnézetet küldtem. Jóváhagyás után minden csatornán ütemezem, hétfőn kapsz eredmény-riportot. 🚀" },
      ],
    },
  },
  crossLinks: {
    title: "A marketing nem áll meg itt",
    subtitle: "Ugyanaz az asszisztens tervezi a foglalásaidat, írja a weboldalad szövegeit és kezeli az ügyfélkapcsolataidat.",
  },
  cta: {
    title: "Indítsd el a marketinget ma",
    subtitle: "3 nap ingyenes próba, kártya nélkül.",
    primary: "Próbáld ki 3 napig ingyen",
    secondary: "Árak megnézése",
  },
};
